export default __webpack_public_path__ + "static/media/landingLogin.6bec5899.PNG";